import {Label as UILabel} from "@headlessui/react";
import clsx from "clsx";

export const Label: React.FC<React.ComponentProps<"label"> & {required?: boolean}> = ({
  required,
  className,
  ...props
}) => {
  return (
    <UILabel {...props} className={clsx("block mb-2 text-sm text-blackout font-bold", className)}>
      {props.children}
      {required && <span className="text-red-500"> *</span>}
    </UILabel>
  );
};
